module.exports = __webpack_public_path__ + "img/rank-adm5.98e2006b.png";